import { render } from "./Other.vue?vue&type=template&id=23bf05de"
const script = {}

import exportComponent from "/Users/yangxinyuan/yxy9022/lit-note/node_modules/.pnpm/vue-loader@17.1.1_vue@3.3.2+webpack@5.82.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__